import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ShoppingCartAdded = function ShoppingCartAdded(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181b32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    viewBox: "0 0 25.19 21",
    className: className,
    width: 1.19 * size,
    height: size,
    children: /*#__PURE__*/_jsx("g", {
      id: "prefix__Capa_2",
      "data-name": "Capa 2",
      children: /*#__PURE__*/_jsxs("g", {
        id: "prefix__Capa_1-2",
        "data-name": "Capa 1",
        children: [/*#__PURE__*/_jsx("path", {
          fill: !ignoreColor ? color : undefined,
          d: "M10.69 21a2.78 2.78 0 01-2.77-2.8 2.7 2.7 0 012.77-2.7 2.76 2.76 0 012.77 2.7 2.83 2.83 0 01-2.77 2.8zm0-3.5a.8.8 0 10.79.8c-.09-.5-.39-.8-.79-.8zM18.91 21a2.78 2.78 0 01-2.77-2.8 2.7 2.7 0 012.77-2.7 2.75 2.75 0 110 5.5zm0-3.5a.8.8 0 10.79.8.78.78 0 00-.79-.8z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M25 4.1a.9.9 0 00-.79-.4H6.4L5.64.9a1 1 0 00-.89-.7L1 0a1 1 0 000 2l3.07.1.67 2.51a.86.86 0 000 .39l2.58 9.3a1.06 1.06 0 001 .7h13.26a1 1 0 001-.7c.89-3.1 1.69-6.2 2.58-9.3a1 1 0 00-.16-.9zm-6 3.5l-4.33 4.88a.86.86 0 01-.58.27.84.84 0 01-.6-.23l-2.16-2.14a.81.81 0 111.14-1.15L14 10.76l3.77-4.24A.82.82 0 0119 6.46a.81.81 0 010 1.14z",
          fillRule: "evenodd",
          fill: !ignoreColor ? color : undefined
        })]
      })
    })
  });
};
export default ShoppingCartAdded;